{
  "清冷仙系": { "primary": "#8F82B8", "secondary": "#D9D5EE", "surface": "#F6F2FA", "ink": "#343047", "accent": "#B8A56B" },
  "温润公子系": { "primary": "#688EA2", "secondary": "#BFD6E2", "surface": "#F5EFE5", "ink": "#344650", "accent": "#B68C42" },
  "智谋权谋系": { "primary": "#526E61", "secondary": "#C9D1C5", "surface": "#EDEBDD", "ink": "#273D35", "accent": "#9A7B3E" },
  "铁血将军系": { "primary": "#6F2530", "secondary": "#24364F", "surface": "#F2EEE9", "ink": "#32242A", "accent": "#A88B55" },
  "危险宿命系": { "primary": "#7B2027", "secondary": "#3B203F", "surface": "#F1E9EC", "ink": "#291B2C", "accent": "#AD8C59" },
  "鲜活成长系": { "primary": "#244D82", "secondary": "#E9A84A", "surface": "#F7F0E6", "ink": "#26384E", "accent": "#C45B42" }
}
